/******************************************************************************
 * Copyright (c) 2016 - 2021.                                                 *
 * Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)          *
 * All Rights Reserved.                                                       *
 *                                                                            *
 * The software and data contained herein are confidential and proprietary    *
 * information of Yega Yazilim ("Confidential Information").                  *
 *                                                                            *
 * Users of this software may not disclose such Confidential Information and  *
 * shall use it only in accordance with the terms of the license agreement    *
 * they entered into with Yega Yazilim.                                       *
 *                                                                            *
 * Author:  Ahmet Dogramaci                                                   *
 * Date:    2021-10-11                                                        *
 ******************************************************************************/

import spinner_axios from '../utils/spinner-axios';

export default {
    methods:{
        registerLoadingSpinnerInterceptor(){
            let store = this.$store;
            spinner_axios.interceptors.request.use(function (config) {
                store.commit('LoadingSpinnerStore/increment');
                return config;
            }, function (error) {
                store.commit('LoadingSpinnerStore/decrement');
                return Promise.reject(error);
            });
            spinner_axios.interceptors.response.use(function (response) {
                store.commit('LoadingSpinnerStore/decrement');
                return response;
            }, function (error) {
                store.commit('LoadingSpinnerStore/decrement');
                return Promise.reject(error);
            });
        }
    },
    created(){
        this.registerLoadingSpinnerInterceptor();
    }
}
